import get from 'lodash.get';

const getDomain = (rootState) => get(rootState, "config.service['yola-template-gallery'].domain");

export default getDomain;
